import { Component, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { DialogDeleteGenericComponent } from '@app/shared/components/dialog-delete-generic/dialog-delete-generic.component';
import { NotificationType } from '@app/shared/interfaces';
import { DeviceDetectionService } from '@app/shared/services/device-detection/device-detection.service';
import { ToastNotificationsService } from '@app/shared/services/toast-notifications/toast-notifications.service';
import { of } from 'rxjs';
import { catchError, map, startWith } from 'rxjs/operators';
import { DirectService, PromoCode, PromoCodeType } from '../../services/direct.service';

@Component({
  standalone: false,
  templateUrl: './direct-promo-codes.component.html',
  styleUrls: ['./direct-promo-codes.component.scss'],
})
export class DirectPromoCodesComponent implements OnInit {
  isMobile$ = this.deviceDetectionService.isMobileViewport();

  vm$ = this.directService.getPromoCodes().pipe(
    map((data) => ({ data: data, loading: false, error: false })),
    startWith({ data: null, loading: true, error: false }),
    catchError((e) => of({ data: null, loading: false, error: 'Error fetching promo codes' }))
  );

  PromoCodeType = PromoCodeType;

  constructor(
    private directService: DirectService,
    private toast: ToastNotificationsService,
    private dialog: MatDialog,
    private deviceDetectionService: DeviceDetectionService
  ) { }

  ngOnInit(): void { }

  updateEnabledStatus(code: PromoCode, event: boolean) {
    if (event) {
      this.directService.enablePromoCode(code.uuid).subscribe();
    } else {
      this.directService.disablePromoCode(code.uuid).subscribe();
    }
  }

  deletePrompt(code: PromoCode) {
    const dialogRef = this.dialog.open(DialogDeleteGenericComponent, {
      width: '720px',
      panelClass: 'dialog-delete-generic',
      data: {
        name: `${code.codes.join(', ')}`,
        list: [
          'Any existing bookings that applied this promo code will not be impacted.',
          'This action cannot be undone.',
          'You may want to disable the promo code instead if you might use it again in the future.',
        ],
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.deleteCode(code);
      }
    });
  }

  deleteCode(code: PromoCode) {
    this.directService.deletePromoCode(code.uuid).subscribe((_) => {
      this.vm$ = this.directService.getPromoCodes().pipe(
        map((data) => ({ data: data, loading: false, error: false })),
        startWith({ data: null, loading: true, error: false }),
        catchError((e) => of({ data: null, loading: false, error: 'Error fetching promo codes' }))
      );
    });
  }

  codeCopied() {
    this.toast.open('Copied to clipboard', 'Dismiss', NotificationType.Success, 2500);
  }
}
